module.exports = __webpack_public_path__ + "img/img_index_scene_beike@2x.96a93f20.png";